export type DigitalData = {
  environment: EnvironmentDigitalData | '';
  dl_version: string;
  application: string;
  site_version: string;
  page_info: PageInfoDigitalData;
  user: UserDigitalData;
  page_error: PageErrorDigitalData;
  process: ProcessDigitalData;
  custom: CustomDigitalData;
};

export type PageInfoDigitalData = {
  brand: string;
  page_type: string;
  country: string;
  channel: string;
  url: string;
  referrer: string;
  language: string;
};

export type UserDigitalData = {
  client_user_id: string;
  user_status: UserStatusDigitalData | '';
  client_product_type: string;
  email: string | '';
  phone: string | '';
  first_name: string | '';
  last_name: string | '';
  gender: GenderDigitalData | '';
  address: AddressDigitalData;
};

export type PageErrorDigitalData = {
  error_type: string;
  error_message: string;
};

export type ProcessDigitalData = {
  process_id: string;
  full_operation_id: string;
  registration_operation_id: string;
  transaction_id: string;
  flow_id: string;
  step_number: string;
  step_description: string;
  step_common: string;
  step_basic: string;
  step_version: string;
  progress_id: string;
  purchase_price: string;
  modality: string;
  product_name: string;
};

export type CustomDigitalData = {
  customer_status: string;
  policyholder_type: string;
  policyholder_birthday: string;
  insurance_start_date: string;
  insurance_modalities_offered: string;
  insurance_prices_offered: string;
  quoting_id: string;
  voucher: string;
  customer_id: string;
  phone: string;
  zip_code: string;
  profession: string;
  previous_insurance_brand: string;
  prev_insurer_canceled: string;
  claim_report_365_days: YesNoDigitalData | '';
  previous_insurance_duration: string;
  payment_method: string;
  test_user: string;
};

export type AddressDigitalData = {
  street: string | '';
  house_number: string | '';
  city: string | '';
  zip_code: string | '';
  country: string | '';
};

export const EnvironmentDigitalData = {
  PRODUCTION: 'production',
  DEVELOPMENT: 'development',
} as const;
export type EnvironmentDigitalData = (typeof EnvironmentDigitalData)[keyof typeof EnvironmentDigitalData];

export const StepBasicDigitalData = {
  QUOTING_START: 'p1:quoting start',
  PRICE_VIEW: 'p2:price view',
  PURCHASING_START: 'p3:purchasing start',
  PURCHASING_END: 'p4:purchasing end',
} as const;
export type StepBasicDigitalData = (typeof StepBasicDigitalData)[keyof typeof StepBasicDigitalData];

export const UserStatusDigitalData = {
  LOGGED: 'logged',
  NOT_LOGGED: 'not logged',
} as const;
export type UserStatusDigitalData = (typeof UserStatusDigitalData)[keyof typeof UserStatusDigitalData];

export const YesNoDigitalData = {
  YES: 'y',
  NO: 'n',
} as const;
export type YesNoDigitalData = (typeof YesNoDigitalData)[keyof typeof YesNoDigitalData];

export const CustomerStatusDigitalData = {
  NEW_CUSTOMER: 'new customer',
  EXISTING_CUSTOMER: 'existing customer',
} as const;
export type CustomerStatusDigitalData = (typeof CustomerStatusDigitalData)[keyof typeof CustomerStatusDigitalData];

export const GenderDigitalData = {
  Female: 'female',
  Male: 'male',
  None: 'none',
};
export type GenderDigitalData = (typeof GenderDigitalData)[keyof typeof GenderDigitalData];
